import {Injectable} from "@angular/core";
import PlatformConnectionProfileInsightModel from "../../model/platformConnectionProfileInsight.model";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";

@Injectable()
export default class ProfileInsightService {
    public constructor(private http: HttpClient) {
    }

    public update(profileInsight: PlatformConnectionProfileInsightModel): Observable<PlatformConnectionProfileInsightModel> {
        return this.http.put<PlatformConnectionProfileInsightModel>(environment.apiUrl + '/profile-insights/' + profileInsight.id, profileInsight);
    }

    public create(profileInsight: PlatformConnectionProfileInsightModel): Observable<PlatformConnectionProfileInsightModel> {
        return this.http.post<PlatformConnectionProfileInsightModel>(environment.apiUrl + '/profile-insights', profileInsight);
    }

    public show(id: number): Observable<PlatformConnectionProfileInsightModel> {
        return this.http.get<PlatformConnectionProfileInsightModel>(environment.apiUrl + '/profile-insights/' + id);
    }
}
